<div class="call-logs-container">
  <call-logs [user]="user"></call-logs>
</div>